<template>
	<div>
		000
		<button @click="code0001">获取验证码</button>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				// 可以在这里定义变量存储返回的验证码数据
				checkCode: ''
			};
		},
		mounted() {
			// 如果需要页面加载时就执行，可以取消注释：
			// this.code0001();
		},
		methods: {
			// 替换后的获取验证码方法
			code0001() {
				const config = {
					method: 'get',
					url: 'http://www.wh360.top/inc/checkcode2.asp',
					headers: {}
				};

				axios(config)
					.then(response => {
						// 1. 在控制台打印
						console.log("验证码返回结果：", JSON.stringify(response.data));

						// 2. 将结果赋值给 data 中的变量（可选）
						this.checkCode = response.data;
					})
					.catch(error => {
						// 请求失败时处理错误
						console.error('获取验证码失败:', error);
						alert('接口调用失败，请检查跨域或网络');
					});
			},
		}
	};
</script>

<style>
</style>